export default "__VITE_ASSET__WyXlTiql__"